const routes = {
    HOME: "/",
    PANELS: "/paneli",
    SPEAKERS: "/predavaci",
    SPONSORS: "/sponzori",
    LOCATION: "/lokacija",
    SPEAKERS_DETAILS: "/predavaci/detalji/",
    PANELS_DETAILS: "/paneli/detalji/",
    PANELS_IMPRESSION: "/paneli/utisak/",
    PANELS_IMPRESSION_DONE: "/uspjesna-recenzija",
    PANELS_FAVORITE: "/paneli/omiljeni",
    REGISTER: "/registracija",
    REGISTER_DONE: "/uspjesna-registracija",
    SUCCESSFUL_PAYMENT_FORWARD: "/placanje-potvrda",
    SUCCESSFUL_EPAYMENT: "/info-uspjesno-placanje",
    FAIL_EPAYMENT: "/info-neuspjesno-placanje"
};

export default routes;
